import React from 'react'
import { Accordion as MUIAccordion, AccordionSummary } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import makeStyles from '@mui/styles/makeStyles'
import { Add, Minus } from 'iconsax-react'

export const StyledAccordion = withStyles(() => ({
  root: {
    border: 'none',
    borderTop: '0.0625rem solid #F1F1F1',
    boxSizing: 'border-box',
    boxShadow: 'none',

    '&:before': {
      display: 'none'
    },

    '& .MuiAccordionSummary-root.Mui-focused': {
      backgroundColor: 'transparent'
    }
  }
}))(MUIAccordion)

export const StyledSummary = withStyles(theme => ({
  root: {
    '& .summaryIcon': {
      color: theme.palette.primary.main,
      fontSize: theme.size.base
    }
  }
}))(({ expanded, ...props }) => {
  const Icon = React.useMemo(() => (expanded ? Minus : Add), [expanded])

  return (
    <AccordionSummary
      expandIcon={<Icon className='summaryIcon' />}
      {...props}
    />
  )
})

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    fontSize: theme.size.sm,
    fontFamily: '"Lato", sans-serif',
    textTransform: 'uppercase',
    color: '#7F8487',

    '& .headerIcon': {
      alignSelf: 'center',
      marginRight: '0.5rem',
      fontSize: theme.size.sm,
      color: 'rgba(0, 0, 0, 0.7)'
    },

    '& .count': {
      marginLeft: '0.5rem',
      color: theme.palette.primary.main
    }
  },

  content: {
    width: '100%'
  },

  show: {
    float: 'right',
    paddingRight: '0.25rem',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    userSelect: 'none',

    '&:hover': {
      color: theme.palette.primary.light
    }
  }
}))

export default useStyles
